export const commonModeule ={
    data() {
        return {
            mediaRecorder:{},
            chunks:[],
            isRecording:false,
            resultInfo: "",
            endMethod:null,
            mobileFlag: false,

        };
    },
    mounted(){
        // this.initMediaDevives();

        this.speech()
        this.mobileFlag = this.isMobileDevice()

    },
    errorCaptured(err, vm, info) {
        console.error('Error captured:', err, 'Vue instance:', vm, 'Info:', info);
        // 返回 false 阻止错误继续向上传播
        return false;
      },
    methods: {
        speech(){
            if ('speechSynthesis' in window) {
                // 浏览器支持语音服务
                var recognition = new webkitSpeechRecognition() || new SpeechRecognition(); // 创建一个语音识别的实例
                
                recognition.continuous = true; // 连续识别，不需要用户每次都按下开始按钮
                recognition.lang = "zh-CN"; // 设置语言
                recognition.interimResults = false; // 是否获取部分识别结果
                recognition.maxAlternatives = 1; // 提供的最大候选识别结果数
             
                // 开始语音识别
                recognition.start();
             
                // // 设置语音识别服务的事件监听
                // recognition.onresult = function(event) {
                //     var result = event.results[event.resultIndex];
                //     console.log(result[0].transcript); // 输出识别的文本
                // };
             
                // recognition.onerror = function(event) {
                //     console.error('Speech Recognition Error: ' + event.error);
                // };
            } else {
                // alert('你的浏览器不支持语音服务。');
                this.initMediaDevives()
            }
        },
        isMobileDevice() {//判断是不是手机端在浏览
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          },
        initMediaDevives(){
            if (navigator.mediaDevices 
            && navigator.mediaDevices.getUserMedia 
            && window.MediaRecorder) {
              navigator.mediaDevices.getUserMedia({ audio: true }).then((stream)=>{
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaRecorder.ondataavailable = (event)=> {
                     this.chunks.push(event.data);
                };
                this.mediaRecorder.onstop = ()=> {
                    let audioBlob = new Blob( this.chunks, { type: 'audio/acc' });
                    this.chunks = []
                    this.uploadAudio(audioBlob)
                }
              })
            }else {
              console.error('浏览器不支持获取麦克风权限或 MediaRecorder API');
            }
        },
        uploadAudio(audioBlob){
            const formData = new FormData();
            formData.append('file', audioBlob);
            this.$axios.post(this.$urls.voiceToText,formData,{
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then((res) => {
                if(res.code == "0" && res.data){
                    this.resultInfo = res.data
                }else{

                }
                this.endMethod(this.resultInfo)
            });
        },
        preventContextMenu(event) {
            event.preventDefault(); // 阻止默认的上下文菜单行为
        },
        startVoice(callback){
            this.resultInfo = ""
            this.mediaRecorder.start();
            console.log('开始录音...',this.mediaRecorder.state);
            callback()
        },
        endVoice(callback){
            if(this.mediaRecorder.state==="recording"){
                this.mediaRecorder.stop();
               this.endMethod = callback
            }
        }
        
    },    
    



}